export const transformPatientPicture = (picture) => {
  if (picture === "#hombre") return "/images/support-extra/hombre.svg";
  if (picture === "#mujer") return "/images/support-extra/mujer.svg";
  if (!picture || picture === "") return "/images/avatar.svg";
  return picture;
};
